import { createTheme } from '@mui/material';
import { defaultStyleComponents } from './defaultStyleComponents';
import { defaultDarkColor, defaultLightColor } from './defaultColors';

export const purpleLightTheme = createTheme({
  components: { ...defaultStyleComponents },
  spacing: (abs: number) => `${0.35 * abs}rem`,
  palette: {
    mode: 'light',
    primary: {
      main: '#B026FF',
      '50': '#F5E5FF',
      '100': '#EACCFF',
      '200': '#D599FF',
      '300': '#C066FF',
      '400': '#AB33FF',
      '500': '#B026FF',
      '600': '#8C1ECC',
      '700': '#681799',
      '800': '#440F66',
      '900': '#220833',
    },
    ...defaultLightColor,
    customColor: {
      main: '#B026FF',
      100: '#8C1ECC',
      gradient:
        'linear-gradient(90deg, rgba(176, 38, 255, 0.1) 0%, rgba(176, 38, 255, 0.3) 100%)',
    },
    customColor2: {
      main: '#141414',
    },
    customColorTable: {
      main: '#B026FF',
      oddRow: '#F5E5FF',
    },
  },
});

export const purpleDarkTheme = createTheme({
  components: { ...defaultStyleComponents },
  spacing: (abs: number) => `${0.35 * abs}rem`,
  palette: {
    mode: 'dark',
    primary: {
      main: '#B026FF',
      '50': '#262626',
      '800': '#220833',
      '200': '#440F66',
      '300': '#681799',
      '400': '#8C1ECC',
      '500': '#B026FF',
      '600': '#AB33FF',
      '700': '#C066FF',
      '100': '#1a1a1a',
      '900': '#141414',
    },
    ...defaultDarkColor,
    customColor: {
      main: '#B026FF',
      100: '#C066FF',
      gradient:
        'linear-gradient(90deg, rgba(20, 20, 20, 0.8) 0%, rgba(176, 38, 255, 0.3) 100%)',
    },
    customColor2: {
      main: '#141414',
    },
    customColorTable: {
      main: '#B026FF',
      oddRow: '#1a1a1a',
    },
  },
});
